<template>
  <!-- 资金支付过程台账 -->
  <div class="contain wageLedger" style="padding:1vh;width:100%;height:100%;">
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>进度产值信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="box" style="overflow: auto;">
      <div class="build-bar" style="font-size:1vw;border-bottom:0;">
        <span style="font-size:1.2vw;margin-right:1vw;">产值进度</span>
        <div style="width: 70%;">
          <el-progress :text-inside="true" :stroke-width="32" :percentage="parseFloat(valueBilv)"></el-progress>
        </div>
      </div>
      <div class="build-bar" style="justify-content: space-between;">
        <div style="display:flex;align-items:center;width: 16vw;">
            <p style="display: flex;align-items: center;margin-right:1vw;">总产值：<span v-if="isTotal">{{totalValue_view}}</span><el-input v-model="total" v-else style="width:8vw;margin-right:0.5vw;"></el-input> 万</p>
            <!-- <el-button type="text" v-if="isTotal" @click="isTotal=false">编辑</el-button>
            <el-button type="text" v-if="!isTotal" @click="isTotal=true">确定</el-button> -->
        </div>
        <div style="display:flex;justify-content: space-between;align-items:center;width:30%">
            <el-date-picker
                v-model="year"
                @change="doFilter"
                type="year"
                value-format="yyyy"
                placeholder="选择年"
                style="margin:auto;width:130px;font-size:12px"
            ></el-date-picker>
            <el-button v-if="totalValue_view" type="success" icon="el-icon-plus" @click="addQin">添加</el-button>
        </div>
      </div>
      <div class="box-content">
        <el-table :data="listData" border stripe height="100%" style="width: 100%;">
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="60" type="index"></el-table-column>
          <el-table-column label="月份">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-date-picker
                  v-model="master.month"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月">
                </el-date-picker>
              </span>
              <span v-else>{{ scope.row.month }}</span>
            </template>
          </el-table-column>
          <el-table-column label="本月产值(万元)">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-input size="mini" placeholder="请输入内容"  @input="getValue" v-model="master.monthPay"></el-input>
              </span>
              <span v-else>{{ scope.row.monthPay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="累计产值(万元)">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-input size="mini" placeholder="累计产值"   v-model="master.cumulativePay" disabled></el-input>
              </span>
              <span v-else>{{ scope.row.cumulativePay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.isSet" size="mini" type="primary" @click="pwdChange(scope.row,scope.$index,true)">保存</el-button>
                <el-button v-else type="primary" size="mini" @click="pwdChange(scope.row,scope.$index,true)">修改</el-button>
                <!-- <span
                  class="el-tag el-tag--info el-tag--mini"
                  style="cursor: pointer;margin-right: 10px;padding:1vh 1vw;"
                  @click="pwdChange(scope.row,scope.$index,true)"
                >{{scope.row.isSet?'保存':"修改"}}</span> -->
                <!-- <span
                  @click="delChange(scope.row,scope.$index,true)"
                  v-if="!scope.row.isSet"
                  class="el-tag el-tag--danger el-tag--mini"
                  style="cursor: pointer;"
                >删除</span> -->
                <el-button v-if="scope.row.isSet" size="mini" @click="pwdChange(scope.row,scope.$index,false)" type="info">取消</el-button>
                <el-button v-else type="danger" size="mini" @click="delChange(scope.row,scope.$index,true)">删除</el-button>
                <!-- <span
                  v-if="scope.row.isSet"
                  class="el-tag el-tag--mini"
                  style="cursor: pointer;"
                  @click="pwdChange(scope.row,scope.$index,false)"
                >取消</span> -->
              </template>
            </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      // search:{
      //     applyMonth:util.myTime.getCurMonth(),
      // },
      listData: [],
      groupId: '',
      // num:{
      //     money:0,
      //     person:0
      // },
      // uploadUrl: myHttp.importExcelEPM, //上传地址
      // uploadHead: {
      //   accessToken: this.$store.state.token,
      // },
      // uploadData: {
      //   entProjectId: '',
      //   attachmentTypeId: '',
      //   userId: util.session.get('user').id,
      // },
      // uploadUrl1: base.url + '/upload/uploadPhoto', //上传付款评依地址
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      // entProjectId: '',
      attachmentTypeId: '',
      master: {
        settlementId: '',
        month:'',
        projectId:'',
        contractMoney: '', //合同价款（万元）
        cumulativePay: '',  //累计付款（万元）
        receivingUnit: '',  //累计付款（万元）
        monthFinish: '', //本月完成工程量(%)
        cumulativeFinish: '', // 累计完成工程量(%
        monthPay: '',  //本月付款金额(万元)
        payRate: '',  //付款比率
        remark: '',   // 备注
      },
      isAddFlag: false,
      proType:[],
      type:'',
      chooseDate: util.myTime.getCurTime(),
      projectId:'',
      projectName:'',
      name:'',
      year:'',// 年
      
      joinType:'2',
      projects:[],
      searchPro:[], //搜索的
      total:2000,
      isTotal:true,

      totalValue_view:'',
      valueBilv:0,
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    // this.entProjectId = this.$route.params.id
    // this.attachmentTypeId = this.$route.params.type
    // this.getData()
    // this.getAll()
     this.getMoney()
  },
  methods: {
    doFilter() {
      this.getData()
    },
    //点击过滤
    showProjectFun(index) {
      this.search.unit = index
      this.getData()
    },
    //获取数据
    getData() {
      var that = this
      myHttp.projectSettlementList({
        projectId:this.groupId,
        year:this.year,
        pageNum:1,
        pageSize:1000
      }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.projectSettlementList.list || []
            // var num = {money:0,person:list.length};
            var bilv = 0
            for (var i = 0; i < list.length; i++) {
              // list[i].bilv =
              //   list[i].planPrepaidMoney && list[i].planPrepaidMoney != 0? ((parseFloat(list[i].prepaidMoney) /parseFloat(list[i].planPrepaidMoney)) *100).toFixed(2) : 0
              //   list[i].paymentVoucher =list[i].paymentVoucher && '' != list[i].paymentVoucher? base.httpCtx + list[i].paymentVoucher  : ''
              //    if ('' != list[i].paymentVoucher) {
              //   list[i].paymentVouchers = []
              //   list[i].paymentVouchers.push(list[i].paymentVoucher)
              // }
               list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
               list[i].isSet = false
               if(i==0){
                 bilv = (parseFloat(list[0].cumulativePay)/parseFloat(that.totalValue_view)*100).toFixed(2)
               }
            }
            that.valueBilv = bilv
            that.listData = list

            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
            
          } else {
            that.dataText = '暂无数据'
          }
        })
    },

    //获取列表最大时间
    getMonthMax(){
      var result = ''
      if(this.listData.length>0){
        var max = ''
        for(var i=0;i<this.listData.length;i++){
          if(max==''){
            max = this.listData[i].month
          }else{
            if(new Date(max).getTime()<new Date(this.listData[i].months).getTime()){
              max = this.listData[i].month
            }
          }
        }
        var month = new Date(max).getMonth()
        var date = new Date(max).setMonth(month + 1)
        result = util.myTime.getCurMonth(date)
      }
      return result;
    },

    //添加
    addQin() {
      if (this.isAddFlag) {
        this.$message.warning('请先保存当前台账')
        return
      } else if (this.master.settlementId != '') {
        this.$message.warning('请先保存当前编辑项')
        return
      }
      this.isAddFlag = true
      this.master = {
        settlementId: '',
        month:'',
        projectId: '',
        contractMoney: '', //合同价款（万元）
        cumulativePay: '', //累计付款（万元）
        receivingUnit: '', //累计付款（万元）
        monthFinish: '', //本月完成工程量(%)
        cumulativeFinish: '', // 累计完成工程量(%
        monthPay: '0', //本月付款金额(万元)
        payRate: '0', //付款比率
        remark: '', // 备注
        isSet: true,
        totalId:''
      }
      this.master.month =  this.getMonthMax()
     
      this.listData.unshift(this.master)
    },


    //修改
    pwdChange(row, index, cg) {
      //点击修改 判断是否已经保存所有操作
      var that = this

      console.log(1111)
      if (
        (this.master.settlementId != '' &&
          this.master.settlementId != row.settlementId) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
      //}
      //是否是取消操作
      if (!cg) {
        //if (!app.master_user.sel.id) app.master_user.data.splice(index, 1);
        this.getData()
        this.master = {
          settlementId: '',
          month: '',
          projectId: '',
          contractMoney: '', //合同价款（万元）
          cumulativePay: '', //累计付款（万元）
          receivingUnit: '', //累计付款（万元）
          monthFinish: '', //本月完成工程量(%)
          cumulativeFinish: '', // 累计完成工程量(%
          monthPay: '0', //本月付款金额(万元)
          payRate: '0', //付款比率
          remark: '', // 备注
        }
        this.isAddFlag = false
        return (row.isSet = !row.isSet)
      }
      //提交数据
      if (row.isSet) {
        //项目请求操作
        var that = this
        this.master.entId = this.entId
        this.master.projectId = this.groupId
        this.master.totalId = this.totalId
        if (this.master.settlementId == '') {
          myHttp.addProjectSettlement(this.master).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加成功')
              that.isAddFlag = false
              that.getData()
              that.master = {
                id: '',
                settlementId:'',
                contractMoney: '', //合同价款（万元）
                cumulativePay: '', //累计付款（万元）
                receivingUnit: '', //累计付款（万元）
                monthFinish: '', //本月完成工程量(%)
                cumulativeFinish: '', //累计完成工程量(%)
                monthPay: '', //本月付款金额(万元)
                payRate: '', //付款比率
                remark: '', // 备注
              }
              return (row.isSet = !row.isSet)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          // console.log(that.listData)
          myHttp.editProjectSettlement(this.master).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('保存成功')
              that.getData()
              that.isAddFlag = false
              that.master = {
                id: '',
                settlementId:'',
                contractMoney: '', //合同价款（万元）
                cumulativePay: '', //累计付款（万元）
                receivingUnit: '', //累计付款（万元）
                monthFinish: '', //本月完成工程量(%)
                cumulativeFinish: '', //累计完成工程量(%)
                monthPay: '', //本月付款金额(万元)
                payRate: '', //付款比率
                remark: '', // 备注
              }
              return (row.isSet = !row.isSet)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
      } else {
        this.master = {
          settlementId: row.settlementId,
          month: row.month,
          projectId: row.projectId,
          contractMoney: row.contractMoney,
          // cumulativePay: row.cumulativePay,
          receivingUnit: row.receivingUnit,
          monthFinish: row.monthFinish,
          cumulativeFinish: row.cumulativeFinish,
          monthPay: row.monthPay,
          payRate: row.payRate,
          remark: row.remark,
        }
        row.isSet = true
      }
    },
    // 删除
    delChange(row, index, cg) {
      var that = this
      //for (let i of this.master) {
      if (
        (this.master.settlementId != '' &&
          this.master.settlementId != row.settlementId) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
      this.$confirm('此操作将删除该调数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteProjectSettlement({
              settlementId: row.settlementId,
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch((err) => {})
    },
    watchInput(e){
      this.projectName = e
      this.doFilter()
    },
      // 总产值回显
     getMoney(){
         var that = this
        myHttp.totalInformation({
          projectId: this.groupId,
        }).then(function (resp) {
          if (resp.data.code == '200') {
            if(resp.data.data){
               that.totalValue_view = resp.data.data.totalValue
               that.totalId = resp.data.data.totalId
              //  that.entId = resp.data.data.entId
              
               that.getData()
            }else{
              that.totalValue_view =''
                  that.totalId = ''
                  that.dataText="暂无数据"
            }
          }
        })
     },
    //  getValue(e){
    //   this.master.monthPay = e
    //    console.log(this.master.monthPay)
    //    console.log(e)
    //  }
  },
}
</script>
<style scoped>
/* .contain {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 1%;
} */
.header-box {
  padding: 15px 20px;
  height: 70px;
  width: 100%;
  box-shadow: 1px 2px 3px 2px #ddd;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  text-align: left;
}
.box {
  /* margin-top: 15px; */
  width: 100%;
  height: calc(100% - 2vh);
}
.box-content {
  width: 100%;
  height: calc(100% - 12vh);
  background: #fff;
}
.box-content-item {
  width: 100%;
  background: #fff;
  min-height: 200px;
  margin-top: 6px;
  display: flex;
  align-content: center;
  align-items: center;
  box-sizing: border-box;
}
.box-content-item .cell {
  width: 33%;
  padding-left: 50px;
  text-align: left;
}
.box-content-item .row {
  width: 100%;
}
.box-content-item .row .warning {
  color: red;
}
.wrap {
  display: flex;
  flex-wrap: wrap;
}
.build-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 6vh;
  background: #fff;
  border-bottom: 3px solid #f5f5f5;
  padding: 0 20px;
}
/* 字体颜色 */
.font-color1 {
  color: #ffbc01;
}
.font-color2 {
  color: #0085ff;
}
.upload-demo {
  margin: 0 20px;
}
</style>
<style>
.build-bar span {
  margin-left: 0;
}
.el-table td,
.el-table th {
  text-align: center;
}
.el-pagination {
  background: #fff;
  padding: 15px 0;
}
.build-bar > .el-button--success {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.el-image .el-icon-circle-close {
  color: #fff;
}
/* .wageLedger .el-button {
  color: #fff;
  background: #1890ff;
} */
</style>
<style>
  @import '../../../assets/css/common.css'
</style>